// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2498": "6c28ee4b4921","6563": "c118f70d3cdb","8696": "bbb68422bd59","8795": "771c29ae18b2","927": "f921d25b46de",}[chunkId] + ".css"
}